import PropTypes from 'prop-types';
import React from 'react'
import { findWhere } from 'underscore'

import Questions from '../RegistrationParts/QuestionsTemplate'


export default class extends React.Component {
    static propTypes = {
		changeData: PropTypes.func.isRequired,
		prevSlide: PropTypes.func.isRequired,
		nextSlide: PropTypes.func.isRequired,
		sessionUser: PropTypes.object.isRequired
	};

    constructor(props) {
        super(props);
        var questions = [
			{
				field: 'clients_lined_up',
				text: 'Do you have clients lined up?',
				subQuestion: {
					condition: 'true',
					text: 'Do you have clients lined up?',
					answers: [
						"Not as many as I'd like",
						"Just the right amount",
						"More than I can cope with"
					]
				}
			},
			{
				field: 'trading_internationally',
				text: 'Are you hoping to trade internationally?'
			},
			{
				field: 'vat_registered',
				text: 'Are you VAT registered or do you expect to be in the next 12 months?',
				subQuestion: {
					condition: 'true',
					text: 'Are you VAT registered or do you expect to be in the next 12 months?',
					answers: [
						"I already am",
						"Definitely will be",
						"I might be"
					]
				}
			}
		]
        questions.map(question => {
			if( question.field in props.sessionUser.custom ) question.answer = props.sessionUser.custom[question.field]
			if( (question.field + '_follow') in props.sessionUser.custom ) question.subQuestion.answer = props.sessionUser.custom[question.field + '_follow']
		})

        this.state = {
			questions: questions
		};
    }

    render() {

		return (

			<Questions 
				changeData={this.props.changeData}
				prevSlide={this.props.prevSlide}
				nextSlide={this.props.nextSlide}
				title="Three client questions"
				questions={this.state.questions} />

		)

	}
}



// WEBPACK FOOTER //
// ./src/js/views/Registration/RegistrationSlides/ClientsSlidePart.jsx